export default __webpack_public_path__ + "static/day-6-6ad7e77b264140b255d13fc7095cdc76.gif";